import type { MessageKey } from 'types/LocaleMessageKey';

import {
  GEN3_POP_PATHNAME,
  STORE_ACCESSORIES_ROOT_PATH,
} from '@/app/consts/pathnames';

import type CurrentRouteValues from '../_hooks/useCurrentRoute/types';
import WizStepId from '../_steps/enums/WizStepId';

export interface Breadcrumb {
  title: MessageKey;
  enumVal: WizStepId;
  checkIsValid: (steps: CurrentRouteValues) => boolean;
  getHref: (currentRoute: CurrentRouteValues) => string;
  isAccessory?: boolean;
}

//Must have conditonal check for href to stop trailing back slash error
const BREADCRUMBS: Breadcrumb[] = [
  {
    title: 'step_style_model_tab',
    enumVal: WizStepId.Accessory,
    checkIsValid: ({ accessory }) => accessory.isValid,
    getHref: ({ accessory }) =>
      accessory.isValid
        ? `${STORE_ACCESSORIES_ROOT_PATH}/${accessory.value}`
        : '',
    isAccessory: true,
  },
  {
    title: 'step_style_title',
    enumVal: WizStepId.Style,
    checkIsValid: ({ style }) => style.isValid,
    getHref: ({ style }) =>
      style.isValid ? `${GEN3_POP_PATHNAME}/${style.value}` : '',
    isAccessory: false,
  },
  {
    title: 'step_finish_title',
    enumVal: WizStepId.Finish,
    checkIsValid: ({ finish }) => finish.isValid,
    getHref: ({ style, finish }) =>
      finish.isValid
        ? `${GEN3_POP_PATHNAME}/${style.value}/${finish.value}`
        : '',
    isAccessory: false,
  },
  {
    title: 'step_size_title',
    enumVal: WizStepId.Size,
    checkIsValid: ({ size }) => size.isValid,
    getHref: ({ accessory, size }) =>
      size.isValid
        ? `${STORE_ACCESSORIES_ROOT_PATH}/${accessory.value}/${size.value}`
        : '',
    isAccessory: true,
  },
  {
    title: 'step_size_title',
    enumVal: WizStepId.Size,
    checkIsValid: ({ size }) => size.isValid,
    getHref: ({ style, finish, size }) =>
      size.isValid
        ? `${GEN3_POP_PATHNAME}/${style.value}/${finish.value}/${size.value}`
        : '',
    isAccessory: false,
  },
];

export default BREADCRUMBS;
